<template>
    <div class="w-full">

        <h4 class="mb-3">API Keys</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addKeyPrompt = true">Add</vs-button>

        <vx-card id="keysDiv"  class="vs-con-loading__container">

            <vs-table ref="table" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="token">Token</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].token">
                            {{ data[index].token }}
                        </vs-td>

                        <vs-td>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-trash-2" color="danger" class="md:mb-0 mr-3 mb-1" @click="removeKey(data[index].id)"/>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <vs-popup title="Add Key" :active.sync="addKeyPrompt">
            <div id="addKeyDiv" class="vs-con-loading__container" >
                <p class="mt-6">Name</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addKey">Add</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>

export default {
    data(){
        return {

            itemsPerPage: 20,
            isMounted: false,

            keys: [],

            addKeyPrompt: false,

            addObject: {}

        }
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#keysDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this
            const loadPromise = this.$http.get('/api/management/v1/api_key/')
            loadPromise.then(function(response) {
                thisIns.keys = response.data
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#keysDiv > .con-vs-loading')
            })
        },
        addKey() {
            this.$vs.loading({
                container: '#addKeyDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this

            const addPromise = this.$http.post('/api/management/v1/api_key/', {
                name: this.addObject.name
            })

            addPromise.then(function() {
                thisIns.addKeyPrompt = false
                thisIns.$printSuccess('Key added')
                thisIns.$nextTick(() => {
                    thisIns.loadData();
                })
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#addKeyDiv > .con-vs-loading')
            })
        },
        removeKey(id) {
            this.$vs.loading({
                container: '#keysDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this

            const removePromise = this.$http.delete('/api/management/v1/api_key/' + id)

            removePromise.then(function() {
                thisIns.$printSuccess('Key removed')
                thisIns.$nextTick(() => {
                    thisIns.loadData()
                })
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#keysDiv > .con-vs-loading')
            })
        }
    },
    computed: {
        currentPage() {
            if (this.isMounted) {
                return this.$refs.table.currentx
            }
            return 0
        },
        tableItems() {
            if (this.isMounted) {
                return this.$refs.table.queriedResults.length
            }
            return 0
        },
        tableData() {
            return this.keys
        }
    },
    mounted() {
        this.isMounted = true
        this.loadData()
    }
}

</script>
